<template>
    <div class="exam-wrap">
        <div class="btns_1">【初级会计实务】交卷完成。</div>
        <div class="btns_2">确定（{{ countdownTime }}秒）</div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            dialogVisible: false,
            pc_id: '',
            column_id: '',
            countdownTime: 10,
        };
    },
    mounted: function () {
        var that = this;
        var query = that.$route.query;
        if (query.pc_id) {
            that.pc_id = query.pc_id;
            that.column_id = query.column_id;
        }
        // 启动倒计时定时器
        let timer = setInterval(() => {
            this.countdownTime--;
            //$btn.text(`${time}秒后重新获取`);
            // 倒计时结束处理
            if (this.countdownTime <= 0) {
                clearInterval(timer); // 清除定时器
                //this.$router.push("/guide/account/question");
                this.$router.push({
                    path: "/meco/result",
                    query: {
                        pc_id: that.pc_id,
                        column_id: that.column_id,
                    },
                });
            }
        }, 1000); // 1秒执行一次
    },
    methods: {
        goNotice() {
            var that = this;
            that.$router.push({
                path: "/meco/result",
                query: {
                    pc_id: that.pc_id,
                    column_id: that.jsonData.column_id,
                },
            });
        },
    },
};
</script>
<style scoped>
.exam-wrap {
    background: url('https://www.yitku.com/mock/account_7.jpg') no-repeat center center;
    background-size: cover;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    flex-direction: column;
}

.btns_1 {
    width: 100%;
    text-align: center;
    font-size: 24px;
    color: #ff0000;
    line-height: 80px;
}

.btns_2 {
    width: 148px;
    height: 42px;
    background: linear-gradient(180deg, #FFD7B3, #FEA859, #CF6703);
    border-radius: 2px;
    border: 1px solid #A15001;
    line-height: 42px;
    text-align: center;
    color: #fff;
    font-weight: bold;
}
</style>